import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './contexts/AppContext';
import LoginPage from './pages/LoginPage';
import DeveloperLoginPage from './pages/DeveloperLoginPage';
import DeveloperDashboard from './pages/DeveloperDashboard';
import AdminDashboard from './pages/AdminDashboard';
import NGODashboard from './pages/NGODashboard';
import './App.css';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isLoading } = useApp();
  if (isLoading) return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" />
    </div>
  );
  if (!user) return <Navigate to="/" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const AppRoutes = () => {
  const { user } = useApp();
  const getHome = () => {
    if (!user) return <LoginPage />;
    if (user.role === 'developer') return <Navigate to="/developer" replace />;
    if (user.role === 'admin') return <Navigate to="/admin" replace />;
    return <Navigate to="/ngo" replace />;
  };
  return (
    <Routes>
      <Route path="/" element={getHome()} />
      <Route path="/dfij/log/219837/grm" element={<DeveloperLoginPage />} />
      <Route path="/developer" element={
        <ProtectedRoute allowedRoles={['developer']}><DeveloperDashboard /></ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>
      } />
      <Route path="/ngo" element={
        <ProtectedRoute allowedRoles={['ngo']}><NGODashboard /></ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
